import React, { useEffect, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';

const SearchByDate = ({ setDateValueAction, dateValueAction }) => {
  const [dateInputValue, setDateInputValue] = useState(dateValueAction);
  const [dateValue, setDateValue] = useState(dateValueAction);
  const { t } = useTranslation();
  const INVALID_DATE = 'Invalid Date';

  const getDateNoTime = (date = new Date()) => {
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const getDateFilter = (date) => {
    if (date && date.toDateString() !== INVALID_DATE && date.getFullYear() > 999 &&
    today.getTime() >= getDateNoTime(date).getTime()) {
      return format(date, 'yyyy-MM-dd');
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (dateValueAction === null) {
      setDateValue(null);
      setDateInputValue('');
    }
  }, [dateValueAction]);

  const onDateChange = (_date, value) => {
    setDateInputValue(value);
    setDateValue(_date);
    const date = getDateFilter(_date || value);
    const payload = { date };
    setDateValueAction(payload);
  };

  const today = getDateNoTime();
  const [day, month, year] = format(today, 'dd/MM/yyyy').split('/');

  return (
    <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
      <KeyboardDatePicker
        id={'select-date-filter'}
        style={{ width: '100%' }}
        inputVariant='outlined'
        autoOk
        clearable
        disableFuture
        showTodayButton
        cancelLabel={t('searchToolbar:cancel')}
        okLabel={t('searchToolbar:ok')}
        todayLabel={t('searchToolbar:today')}
        clearLabel={t('searchToolbar:clear')}
        invalidDateMessage={t('searchToolbar:invalidFormatDate')}
        minDateMessage={t('searchToolbar:invalidFormatDate')}
        maxDateMessage={t('searchToolbar:invalidMaxDate', { day, month, year })}
        variant='dialog'
        format='dd/MM/yyyy'
        placeholder={t('searchToolbar:format')}
        inputValue={dateInputValue}
        value={dateValue}
        onChange={onDateChange}
        maxDate={getDateNoTime()}
        minDate={getDateNoTime(new Date(1000, 1, 1))}
        label={t('searchToolbar:date')}
        InputLabelProps={{
          shrink: true
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default SearchByDate;
